import { Card, message, Statistic, Table, Tabs } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import PageWrap from '../../components/PageWrap';
import AccountingRecordReportSearch from './components/SearchView';
import { apiPlatformReportExport, fetchPlatformReportList, fetchPlatformReportSummary } from '../../services/platformReport';
import moment from 'moment';
import { handleExportParams, ToParamForObject } from '../../utils';
import AuthButton from '../../components/AuthButton/AuthButton';

import MerchantReportInfo from './components/MerchantReportInfoModal';
const { TabPane } = Tabs;
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-29 10:26:42
 * @LastEditTime: 2021-12-29 10:26:45
 * @LastEditors: zhao - 🍉
 * @Description: 对账报表
 * @FilePath: /zhzj-admin/src/page/AccountingRecordReport/index.jsx
 */

const AccountingRecordReport = (props) => {
    const options = [
        { type: 'null', name: '汇总（建行、宝生）', sumKey: 'summaryMoney'},
        { type: 'null', name: '建行汇总(线上、线下)', sumKey: 'jhSummaryMoney'},
        { type: 'null', name: '宝生汇总(线上、线下)', sumKey: 'bsSummaryMoney'},
    ]

    const newOptions = [
        { type: 1, name: '建行微支付', sumKey: 'jhWxPaySummaryMoney' },
        { type: 2, name: '建行数字人民币', sumKey: 'jhSZRmbSummaryMoney' },
        { type: 3, name: '建行线下转账', sumKey: 'jhOfflineSummaryMoney' },
        { type: 4, name: '建行惠市宝', sumKey: 'jhHsbSummaryMoney' },
        { type: 9, name: '建行其他账单转入', sumKey: 'jhTransferOtherBillSummaryMoney' },
    ]

    const bsOptions = [
        { type: 5, name: '宝生微支付', sumKey: 'bsWxPaySummaryMoney'  },
        { type: 7, name: '宝生子商户微支付', sumKey: 'bsWxPaySubSummaryMoney'  },
        { type: 6, name: '宝生线下转账', sumKey: 'bsOfflineSummaryMoney'  },
        { type: 8, name: '宝生其他账单转入', sumKey: 'bsTransferOtherBillSummaryMoney' },
    ]

    const [queryData, setQueryData] = useState({
        dateType:2,
        month: moment().subtract(0, 'month').format('YYYY-MM')
    });
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [sumData, setSumData] = useState({});
    const [columns, setColumns] = useState([]);
    let MerchantReportInfoRef = useRef(null)
    const [reportFormType, setReportFormType] = useState('1');

    useEffect(() => {
        postReportSum()
    }, [])
    useEffect(() => {
        postReportList()
    }, [reportFormType])

    // 点击查看商户详情
    const handleOpenMerchantInfo = (params, merchantName) => {
        MerchantReportInfoRef.open(params, merchantName)
    }

    // 渲染 表格 可操作的列
    const renderRow = (text, records, e) => {
        // 可点击条件: 1.必须是商户  2.金额大于0  3.非合计行
        if (e.key.indexOf('merchant') > -1 && text > 0 && records.payDate !== '合计' && records.payDate !== '上月结余款') {
            const merchantName = e.value
            const merchantId = e.key.split('_')[1]
            const dateType = queryData.dateType === 1 ? 1 : 2
            const date = records.payDate
            const params = { merchantId, dateType, date, reportFormType }

            return <a onClick={() => handleOpenMerchantInfo(params, merchantName)}>{text}</a>
        }
        return text
    }

    // 解析返回的表格数据
    const parseResponse = (res)=> {
        const columns = res.titleList.map(e => ({title:e.value, dataIndex: e.key, render: (text, records) => renderRow(text, records, e)}))
        const dataSource = res.dataList.map(e => ({...e, ...e.dataValue}))
        const accumulation1 = {...res.merchantLastMonthTotalMoney, totalMoney: res.lastMonthTotalMoney,serviceCharge: res.lastMonthServiceCharge, receivedMoney: res.lastMonthReceivedMoney,payDate: '上月结余款'}
        const accumulation = {...res.merchantTotalMoney, totalMoney: res.totalMoney,serviceCharge: res.serviceCharge, receivedMoney: res.receivedMoney,payDate: '合计'}
        dataSource.push(accumulation1)
        dataSource.push(accumulation)
        setColumns(columns)
        setDataSource(dataSource)
    }

    // 解析表格请求数据
    const formatParams = () => {
        const merchantIds = queryData.merchantIds && queryData.merchantIds.length ? queryData.merchantIds : undefined
        const data = { reportFormType, ...queryData, merchantIds }
        return data
    }
   
    const postReportList = () => {
       const data = formatParams()

        setLoading(true)
        fetchPlatformReportList(data).then(res=> {
            parseResponse(res)
        }).finally(() => setLoading(false))
    }

    const postReportSum = () => {
        const data = formatParams()
        fetchPlatformReportSummary(data).then(res => {
            console.log(res)
            setSumData(res)
        })
    }

    const handleSearch = () => {
        postReportList()
        postReportSum()
    }

    const handleTabChange = (e) => {
        if (e === 'null') return message.warning('该汇总不可查询')

        setReportFormType(e)
    }

    // 导出url参数
    const parmas = ToParamForObject({ 
        ...formatParams(),
        ...handleExportParams()
    })
    const exportUrl = apiPlatformReportExport + '?' + parmas
    return (
        <PageWrap>
             <AccountingRecordReportSearch value={queryData} onChange={setQueryData} onSearch={handleSearch} >
                <AuthButton authkey="e-13-1" icon="download" type="primary" download href={exportUrl}>导出</AuthButton>
            </AccountingRecordReportSearch>
             <Tabs animated={false} activeKey={reportFormType}  onChange={handleTabChange} >
                {options.map(e => {
                    const aa = (
                        <Card size="small"  style={{ minWidth: 160, cursor: e.type === 'null' ? 'not-allowed' : 'pointer' }}>
                            <Statistic prefix={<span style={{fontSize: 12}}></span>} key={e.type} title={e.name} value={sumData[e.sumKey]} />
                        </Card>
                    )
                    return <TabPane tab={aa} key={e.type}  />
                })}
            </Tabs>

            <Tabs animated={false} activeKey={reportFormType}  onChange={handleTabChange} >
                {newOptions.map(e => {
                    const aa = (
                        <Card size="small"  style={{ minWidth: 160, cursor: e.type === 'null' ? 'not-allowed' : 'pointer' }}>
                            <Statistic prefix={<span style={{fontSize: 12}}></span>} key={e.type} title={e.name} value={sumData[e.sumKey]} />
                        </Card>
                    )
                    return <TabPane tab={aa} key={e.type}  />
                })}
            </Tabs>

            <Tabs animated={false} activeKey={reportFormType}  onChange={handleTabChange} >
                {bsOptions.map(e => {
                    const aa = (
                        <Card size="small"  style={{ minWidth: 160, cursor: e.type === 'null' ? 'not-allowed' : 'pointer' }}>
                            <Statistic prefix={<span style={{fontSize: 12}}></span>} key={e.type} title={e.name} value={sumData[e.sumKey]} />
                        </Card>
                    )
                    return <TabPane tab={aa} key={e.type}  />
                })}
            </Tabs>
           

            

            <Table
                loading={loading}
                columns={columns} 
                dataSource={dataSource}
                pagination={false}
            />

            <MerchantReportInfo getRef={ref => MerchantReportInfoRef = ref} />
           
        </PageWrap>
    )
}

export default AccountingRecordReport


// WEBPACK FOOTER //
// ./src/page/AccountingRecordReport/index.jsx